import {
  REFRESH_DATABASE,
  REFRESH_DATABASE_SUCCESS,
  REFRESH_DATABASE_FAILURE
} from "../../store/constants/database";
import {
  FETCH_REGIONS_SUCCESS,
  FETCH_REGIONS_FAILURE,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  FETCH_PRODUCT_VIDEOS_SUCCESS,
  FETCH_PRODUCT_VIDEOS_FAILURE,
  FETCH_SPORT_TYPES_SUCCESS,
  FETCH_SPORT_TYPES_FAILURE,
  FETCH_SPORT_VARIANTS_SUCCESS,
  FETCH_SPORT_VARIANTS_FAILURE,
  FETCH_CONDITIONS_SUCCESS,
  FETCH_CONDITIONS_FAILURE,
  FETCH_WEATHER_PROVIDERS_SUCCESS,
  FETCH_WEATHER_PROVIDERS_FAILURE
} from "../../store/constants/hwk";
import { put, take, takeLatest } from "redux-saga/effects";
import { fetchRegions } from "../actions/regions";
import { fetchProducts } from "../actions/products";
import { fetchProductVideos } from "../actions/productVideos";
import { fetchSportTypes } from "../actions/sportTypes";
import { fetchSportVariants } from "../actions/sportVariants";
import { fetchConditions } from "../actions/conditions";
import { getPushNotificationsStatus } from "../actions/pushNotifications";
import { fetchWeatherProviders } from "../actions/weatherProviders";

function* refreshDatabase(action) {
  /***************************************
   * 0. Fetch PushTokenStatus (non-blocking process)
   ***************************************/
  yield put(getPushNotificationsStatus());


  /***************************************
   * 1. Fetch Regions (blocking process)
   ***************************************/
  yield put(fetchRegions());
  const regionsAction = yield take([
    FETCH_REGIONS_SUCCESS,
    FETCH_REGIONS_FAILURE
  ]);
  if (regionsAction.type === FETCH_REGIONS_FAILURE) {
    yield put({ type: REFRESH_DATABASE_FAILURE, error: regionsAction.error });
    return;
  }

  /***************************************
   * 2. Fetch Products (blocking process)
   ***************************************/
  yield put(fetchProducts());
  const productsAction = yield take([
    FETCH_PRODUCTS_SUCCESS,
    FETCH_PRODUCTS_FAILURE
  ]);
  if (productsAction.type === FETCH_PRODUCTS_FAILURE) {
    yield put({ type: REFRESH_DATABASE_FAILURE, error: productsAction.error });
    return;
  }

  /***************************************
   * 3. Fetch Product Videos (blocking process)
   ***************************************/
  yield put(fetchProductVideos());
  const productVideosAction = yield take([
    FETCH_PRODUCT_VIDEOS_SUCCESS,
    FETCH_PRODUCT_VIDEOS_FAILURE
  ]);
  if (productVideosAction.type === FETCH_PRODUCT_VIDEOS_FAILURE) {
    yield put({
      type: REFRESH_DATABASE_FAILURE,
      error: productVideosAction.error
    });
    return;
  }

  /***************************************
   * 4. Fetch SportTypes (blocking process)
   ***************************************/
  yield put(fetchSportTypes());
  const sportTypesAction = yield take([
    FETCH_SPORT_TYPES_SUCCESS,
    FETCH_SPORT_TYPES_FAILURE
  ]);
  if (sportTypesAction.type === FETCH_SPORT_TYPES_FAILURE) {
    yield put({
      type: REFRESH_DATABASE_FAILURE,
      error: sportTypesAction.error
    });
    return;
  }

  /***************************************
   * 5. Fetch SportVariants (blocking process)
   ***************************************/
  yield put(fetchSportVariants());
  const sportVariantsAction = yield take([
    FETCH_SPORT_VARIANTS_SUCCESS,
    FETCH_SPORT_VARIANTS_FAILURE
  ]);
  if (sportVariantsAction.type === FETCH_SPORT_VARIANTS_FAILURE) {
    yield put({
      type: REFRESH_DATABASE_FAILURE,
      error: sportVariantsAction.error
    });
    return;
  }

  /***************************************
   * 6. Fetch Conditions (blocking process)
   ***************************************/
  yield put(fetchConditions());
  const conditionsAction = yield take([
    FETCH_CONDITIONS_SUCCESS,
    FETCH_CONDITIONS_FAILURE
  ]);
  if (conditionsAction.type === FETCH_CONDITIONS_FAILURE) {
    yield put({
      type: REFRESH_DATABASE_FAILURE,
      error: conditionsAction.error
    });
    return;
  }

  /***************************************
   * 7. Weather Providers (blocking process)
   ***************************************/
  yield put(fetchWeatherProviders());
  const weatherProvidersAction = yield take([
    FETCH_WEATHER_PROVIDERS_SUCCESS,
    FETCH_WEATHER_PROVIDERS_FAILURE
  ]);
  if (weatherProvidersAction.type === FETCH_WEATHER_PROVIDERS_FAILURE) {
    yield put({
      type: REFRESH_DATABASE_FAILURE,
      error: conditionsAction.error
    });
    return;
  }


  /***************************************
   * FINISH UP
   ***************************************/
  yield put({ type: REFRESH_DATABASE_SUCCESS });

}

export default function* rootSaga() {
  yield takeLatest(REFRESH_DATABASE, refreshDatabase);
}
